import { useGetManualPropertyFileTemplatesLazyQuery } from '../../../../__generated__/generated_types';
import { useEffect } from "react";
import { base64ToBlob, downloadDataAsFile } from "../../../../utils/file-helpers";

export interface IFetchManualPropertyTemplateCsv {
    fetchTemplate: (propertyId: string) => void
}

export function useFetchManualPropertyTemplateCsv(budgetYear: number): IFetchManualPropertyTemplateCsv {
    const [getTemplates, {loading, data}] = useGetManualPropertyFileTemplatesLazyQuery(
        {
            fetchPolicy: 'no-cache'
        }
    );

    useEffect(() => {
        if(!loading && data?.getManualPropertyFileTemplates) {
            const csvData = data.getManualPropertyFileTemplates;
            const blob = base64ToBlob(csvData.base64ZipFile, "application/zip");
            downloadDataAsFile(blob, "Templates.zip");
        }
    }, [loading, data]);

    const fetchTemplate = (propertyId: string) => {
        getTemplates({
            variables: {
                propertyId: propertyId,
                budgetYear: budgetYear
            }
        });
    };

    return {
        fetchTemplate
    };
}